
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapState } from 'vuex'
import { mdiInformation } from '@mdi/js'
export default {

  components: {
    ValidationObserver,
    ValidationProvider
  },

  props: {
    disabled: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      mdiInformation,
      question: '',
      submitting: false
    }
  },

  computed: {
    ...mapState('customer', {
      merchantAcceptedByCm24: state => state.merchant?.acceptedByCm24 === true,
      merchantBlocked: state => state.customer?.merchantBlocked
    }),
    ...mapState('product', {
      product: state => state.data
    }),

    waitingForAnswer: {
      get () {
        return this.$store.state.product.data?.context?.waitingForAnswer
      },
      set (value) {
        this.$store.commit('product/setWaitingForAnswer', value)
      }
    }
  },
  methods: {
    ...mapActions('general', [
      'showSnackbar'
    ]),

    async submit () {
      this.submitting = true

      const data = {
        question: this.question
      }

      await this.$axios.post(`/private/auction/question/${this.product?.auction?.auctionId}`, data)
        .then((response) => {
          if (response.status === 200) {
            this.waitingForAnswer = true
            this.showSnackbar({
              text: this.$t('landing.faq.sent'),
              color: 'primary',
              timeout: 5000
            })
          }
        }, (error) => {
          if (error.response?.status === 406) {
            this.showSnackbar({ text: error.response.data, color: 'error' })
          } else {
            this.showSnackbar({
              text: this.$t('question_error'),
              color: 'error'
            })
          }
          this.waitingForAnswer = false
        })

      this.submitting = false

      this.$emit('submitted')
    }

  }

}
